import { singleton } from "tsyringe";

@singleton()
export class PreloaderComponent {
  hide(): Promise<void> {
    return new Promise((res) => {
      const $el = document.querySelector(".preloader") as HTMLImageElement;
      $el.style.opacity = "0";
      $el.addEventListener("transitionend", () => {
        $el.parentElement.removeChild($el);
        res();
      });
    });
  }
}
